import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PagedResponse } from '../../../shared/contract/paged-response.contract';
import { getHttpParameters } from '../../../shared/utils/get-http-parameters';
import { AddOrganisationToUsersCommand } from '../contract/requests/add-organisation-to-users-command.contract';
import { GetUsersRequest } from '../contract/requests/get-users-request.contract';
import { SearchUsersRequest } from '../contract/requests/search-users-request.contract';
import { SearchUser } from '../contract/search-user.contract';

@Injectable({ providedIn: 'root' })
export class UsersApiService {
  private readonly url = environment.APP_USERROLE_SERVICE_BASE_URL + '/api/v1/users';
  private readonly http = inject(HttpClient);

  public getUsers({ page, size }: GetUsersRequest): Observable<PagedResponse<SearchUser>> {
    const httpParams = getHttpParameters({ page, size });

    return this.http.get<PagedResponse<SearchUser>>(this.url, {
      params: httpParams,
    });
  }

  public searchUsers({ page, size, terms }: SearchUsersRequest): Observable<PagedResponse<SearchUser>> {
    let params = getHttpParameters({ page, size });
    params = params.set('terms', terms ?? '');

    return this.http.get<PagedResponse<SearchUser>>(`${this.url}/search/all`, {
      params,
    });
  }

  public getUsersCrossOrganisation({ page, size }: SearchUsersRequest): Observable<PagedResponse<SearchUser>> {
    const httpParams = getHttpParameters({ page, size });

    return this.http.get<PagedResponse<SearchUser>>(`${this.url}/cross-organisation`, {
      params: httpParams,
    });
  }

  public getAssignedOrganisations(): Observable<string[]> {
    return this.http.get<string[]>(`${this.url}/user-assigned-organisations`);
  }

  public addOrganisationToUsers(command: AddOrganisationToUsersCommand): Observable<void> {
    return this.http.post<void>(`${this.url}/add-organisation-to-users`, command);
  }
}
